import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { UpdateAccountGroupsShareService } from "@/features/accounts/account-group/services/update-account-groups-share-service";
import { useContext } from "react";


export const useUpdateAccountGroupsShare = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const updateAccountGroupsShareService = new UpdateAccountGroupsShareService();

  // 口座グループ共有更新
  const updateAccountGroupsShare = async (
    accountGroupId: string,
    sharedId: string,
    sharedStatus: number
  ) => {
    try {
      await updateAccountGroupsShareService.updateAccountGroupsShare({
        account_group_id: accountGroupId,
        shared_id: sharedId,
        shared_status: sharedStatus
      });
    } catch (error) {
      // エラーハンドリング
      console.log("updateAccountGroupsShare:", error);
      return 0;
    } finally {
      //
    }
  };

  return {
    updateAccountGroupsShare: errorHandledAsync(updateAccountGroupsShare, setError),
  };
};
